import { User } from "../user/User";

export class AuditableResponse {
  createdByUser?: User
  createdDate?: string
  
  lastModifiedByUser?: User
  lastModifiedDate?: string

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(createdByUserJson?: any, createdDate?: string, lastModifiedByUserJson?: any, lastModifiedDate?: string) {
    this.createdByUser = createdByUserJson ? new User(createdByUserJson) : undefined
    this.createdDate = createdDate
    this.lastModifiedByUser = lastModifiedByUserJson ? new User(lastModifiedByUserJson) : undefined
    this.lastModifiedDate = lastModifiedDate
  }
}